import React from 'react';

interface A4SheetProps {
  children: React.ReactNode;
  className?: string;
  isPreview?: boolean;
  /** Шрифт превью (например из настроек билдера); при наличии подменяет дефолтный Inter */
  fontFamily?: string;
}

const DEFAULT_FONT = "'Inter', 'Arial', sans-serif";

const A4Sheet: React.FC<A4SheetProps> = ({ 
  children, 
  className = '', 
  isPreview = true,
  fontFamily,
}) => {
  const resumeFont = fontFamily || DEFAULT_FONT;
  return (
    <div 
      className={`a4-sheet ${isPreview ? 'a4-sheet-preview' : 'a4-sheet-print'} ${className}`}
      style={{
        width: '210mm',
        minHeight: '297mm',
        ['--resume-font' as string]: resumeFont,
      }}
    >
      <div className="a4-sheet-content">
        {children}
      </div>
      
      <style dangerouslySetInnerHTML={{
        __html: `
        .a4-sheet {
          position: relative;
          background: white;
          box-sizing: border-box;
          font-family: var(--resume-font, ${DEFAULT_FONT});
          font-size: 1rem;
          line-height: 1.5;
          color: #111;
          word-wrap: break-word;
          overflow: visible;
          width: 210mm;
          min-height: 297mm;
        }
        
        .a4-sheet-preview {
          box-shadow: none;
          border-radius: 0;
          margin: 0;
          transform-origin: top center;
        }
        
        .a4-sheet-print {
          box-shadow: none;
          border-radius: 0;
          margin: 0;
        }
        
        .a4-sheet-content {
          width: 100%;
          min-height: 100%;
          padding: 3mm 5mm;
          box-sizing: border-box;
          overflow: visible;
          position: relative;
        }
        
        /* Для шаблона Современный с сайдбаром - убираем отступы слева и сверху */
        .a4-sheet.template-modern-sidebar-dark .a4-sheet-content {
          padding: 0;
        }
        
        /* Для шаблона Минималистичный моно - равнозначные отступы справа и слева */
        .a4-sheet.template-monochrome-minimal .a4-sheet-content {
          padding: 15mm 15mm;
        }
        
        /* Для новых шаблонов из Figma - без отступов */
        .a4-sheet.template-template-01 .a4-sheet-content,
        .a4-sheet.template-template-02 .a4-sheet-content,
        .a4-sheet.template-template-03 .a4-sheet-content {
          padding: 0;
        }
        
        /* Стили для печати */
        @media print {
          .a4-sheet {
            width: 210mm !important;
            height: 297mm !important;
            min-height: 297mm !important;
            max-height: 297mm !important;
            box-shadow: none !important;
            border-radius: 0 !important;
            margin: 0 !important;
            page-break-after: always;
            page-break-inside: avoid;
          }
          
          .a4-sheet-content {
            padding: 5mm !important;
            width: 100% !important;
            height: 100% !important;
          }
          
          .a4-sheet.template-template-01 .a4-sheet-content,
          .a4-sheet.template-template-02 .a4-sheet-content,
          .a4-sheet.template-template-03 .a4-sheet-content {
            padding: 0 !important;
          }
          
          .a4-sheet:last-child {
            page-break-after: auto;
          }
        }
        
        /* Предотвращение разрывов для важных блоков */
        .avoid-break {
          break-inside: avoid;
          page-break-inside: avoid;
        }
        
        /* Стили для разрывов страниц */
        .page-break-before {
          page-break-before: always;
        }
        
        .page-break-after {
          page-break-after: always;
        }
        
        .page-break-inside-avoid {
          page-break-inside: avoid;
          break-inside: avoid;
        }
      `}} />
    </div>
  );
};

export default A4Sheet;